export default "__VITE_ASSET__09f097c3__"